/** Workflows P5-1: connectors on the canvas (a handle on every exit, drag to connect, the connection menu). */
export const workflowsConnectors = {
  pathExit: "Goes to",
  exitsOf: "Exits of {{step}}",
  to: "→ {{path}}",
  missingPath: "Path {{id}} is missing",
  fallback: { next: "Next step", end: "Ends", unset: "Choose a path" },
  after: { next: "goes to the next step", end: "ends the workflow", unset: "needs a path" },
  handle: {
    connected: "Exit “{{exit}}” of {{step}} in {{path}}: goes to {{target}}",
    missing: "Exit “{{exit}}” of {{step}} in {{path}}: goes to Path {{id}}, which no longer exists",
    next: "Exit “{{exit}}” of {{step}} in {{path}}: not connected, goes to the next step",
    end: "Exit “{{exit}}” of {{step}} in {{path}}: not connected, the workflow ends",
    unset: "Exit “{{exit}}” of {{step}} in {{path}}: not connected, choose a path",
  },
  menu: {
    label: "Connection of “{{exit}}”",
    goTo: "Go to {{path}}",
    connectTo: "Connect to",
    newPath: "New path",
    connected: "Connected",
    delete: "Delete connection",
    deleteKeys: "Del",
  },
  drop: "Drop to connect",
  reasons: {
    self: "Same path",
    loop: "Would loop without waiting",
    trigger: "Not the trigger",
    full: "All {{max}} paths are used",
  },
  refused: {
    self: "An exit can't lead back to its own path.",
    loop: "That would make the path loop without waiting for the visitor. Only a path that waits for an answer can loop.",
    trigger: "Nothing can lead to the trigger: it starts the workflow.",
    full: "All {{max}} paths are used. Delete one before adding another.",
  },
  announce: {
    dragging: "Connecting “{{exit}}”. Drop it on a path, or on empty canvas to make a new path. Escape cancels.",
    connected: "“{{exit}}” now goes to {{path}}.",
    created: "Created Path {{id}} and connected “{{exit}}” to it.",
    deleted: "Connection deleted. “{{exit}}” {{after}}.",
    cancelled: "Connecting cancelled.",
    wentTo: "Moved to {{path}}.",
  },
} as const;
